import { useCreateTypeModelMutation } from "@/hooks";
import { ModelType } from "@/types";
import { TypeModelFields } from "./type-model-fields";

export function FormTypeModelCreate({ handleClose, onCreated }: { handleClose: () => void; onCreated?: (type: ModelType) => void }) {
  const mutation = useCreateTypeModelMutation();
  return <TypeModelFields showSuccessToast={!onCreated} handleClose={handleClose} isLoading={mutation.isLoading} save={async values => {
    const result = await mutation.mutateAsync(values);
    onCreated?.(result);
  }} />;
}
